module.exports = __webpack_public_path__ + "img/neirong@2x.1b7d3746.png";